var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEnterOnAr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.208 6.333-4.583-2.65a1.242 1.242 0 0 0-1.25 0l-4.583 2.65a1.256 1.256 0 0 0-.625 1.084v5.291c0 .45.241.859.625 1.084l4.583 2.65c.383.225.867.225 1.25 0l4.583-2.65c.383-.225.625-.634.625-1.084V7.417c0-.45-.242-.859-.625-1.084Zm-9.375 6.134v-3.85l3.333 1.933v3.842l-3.333-1.925ZM10 9.108 6.667 7.175 10 5.25l3.333 1.925L10 9.108Zm.833 5.284V10.55l3.333-1.933v3.85l-3.333 1.925Zm-5-12.725H2.916c-.691 0-1.25.558-1.25 1.25v2.916h1.667v-2.5h2.5V1.667Zm8.334 0h2.916c.692 0 1.25.558 1.25 1.25v2.916h-1.666v-2.5h-2.5V1.667ZM5.832 18.333H2.916c-.691 0-1.25-.558-1.25-1.25v-2.916h1.667v2.5h2.5v1.666Zm8.333 0h2.917c.692 0 1.25-.558 1.25-1.25v-2.916h-1.666v2.5h-2.5v1.666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
};
export { SvgEnterOnAr as ReactComponent };